import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { Cart2 } from '@styled-icons/bootstrap/Cart2';

import { useStore } from '@/stores/store-provider';

const CartIconWrapper = styled.div`
  align-items: center;
  border-radius: .5em;
  color: ${props => props.theme.colors.typography.primary};
  cursor: pointer;
  display: inline-flex;
  padding: .75em;
  position: relative;

  &:hover {
    .home & {
      background: rgba(0, 0, 0, .125);
    }
  }

  svg {
    color: ${props => props.theme.colors.typography.primary};
  }
`;

const ShoppingCart = styled(Cart2)``;

const Badge = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 1em;
  color: white;
  font-size: .65em;
  padding: 0 .75em 0 .65em;
  position: absolute;
  left: 0;
  text-align: center;
  top: 0;
  transform: translate(120%, 20%);
`;

const CartButton = () => {
  const { toggleCart, totalItems } = useStore();

  return (
    <CartIconWrapper onClick={toggleCart}>
      <ShoppingCart size={24} />
      {totalItems > 0 && <Badge>{totalItems}</Badge>}
    </CartIconWrapper>
  );
};

export default observer(CartButton);
